// src/pages/Dashboard/Dashboard.js
import React, { useContext, useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import MainLayout from "../../components/Layout/MainLayout";
import { UserContext } from "../../contexts/UserContext";
import JobList from "../../components/Jobs/JobList";
import { Button, Modal } from "react-bootstrap";
import { dashboard } from "../../styles/theme";
// import dashboardRoutes from "../../components/Layout/Sidebar/routes";
import { PIPELINE_CONFIG, getFormComponent } from "../../config/pipelineConfig";

import { MdRefresh } from "react-icons/md";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Dashboard = () => {
  const { subpage } = useParams();
  const { user } = useContext(UserContext);


  // fallback to first route slug
  const defaultSlug = PIPELINE_CONFIG[0]?.code || "cro";
  const code = subpage || defaultSlug;

  const [jobs, setJobs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  /* ---------------- Title from route config ---------------- */
  const currentPipeline = PIPELINE_CONFIG.find(p => p.code === code);
  const pageTitle = currentPipeline?.title || PIPELINE_CONFIG[0]?.title || "Dashboard";

  const SelectedForm = getFormComponent(code);



  /* ---------------- Fetch Jobs ---------------- */
  const fetchJobs = useCallback(async () => {
    if (!user) return;

    try {
      const res = await axios.get(`${API_BASE_URL}/api/jobs`, {
        params: {
          userId: user.id,
          code: code,
        },
      });

      setJobs(res.data);
      setLastUpdated(new Date());
    } catch (err) {
      console.error("Error fetching jobs:", err);
    }
  }, [user, code]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  // if (!user) return <p>No user data available.</p>;

  const handleAddJob = async () => {
    try {
      await fetchJobs();
      setShowModal(false);
    } catch (err) {
      console.error("Error submitting job:", err);
    }
  };

  return (
    <MainLayout>
    {/* Header */}
    <div style={dashboard.header}>
      <h2 style={dashboard.title}>{pageTitle}</h2>

      {user && (
        <>
          <MdRefresh
            style={dashboard.refreshIcon}
            title="Refresh job list"
            onClick={fetchJobs}
          />

          {lastUpdated && (
            <span style={dashboard.lastUpdatedText}>
              List last updated:{" "}
              {lastUpdated.toLocaleString("en-US", {
                weekday: "short",
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZoneName: "short",
              })}
            </span>
          )}

          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
            style={dashboard.button}
          >
            Create New Job
          </Button>
        </>
      )}
    </div>

      {currentPipeline?.description && (
        <div style={dashboard.description}>
          {currentPipeline.description}
        </div>
      )}

      {/* Job List */}
      {/* <JobList jobs={jobs} /> */}
      {user ? (
        <>
          {/* Job List */}
          <JobList jobs={jobs} />
        </>
      ) : (
        <div style={{ marginTop: "30px", padding: "20px", background: "#f8f9fa", borderRadius: "8px" }}>
          <h5>Login Required</h5>
          <p>
            You are viewing this pipeline in public mode.
            Please log in to submit jobs and view your analysis history.
          </p>
        </div>
      )}

      {/* Modal */}
      {user && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={dashboard.modalTitle}>
              New {pageTitle} Job
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={dashboard.modalBody}>
            {SelectedForm && (
              <SelectedForm
                onSubmit={handleAddJob}
                code={code}
                user_id={user.id}
              />
            )}
          </Modal.Body>
        </Modal>
      )}

    </MainLayout>
  );
};

export default Dashboard;
